import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

// Models
import { User } from 'src/app/modules/account/models/user';
import { MetaData } from 'src/app/platform/models/utils';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { AccountsService } from 'src/app/modules/account/accounts.service';
import { ProductsService } from 'src/app/modules/products/products.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';

@Component({
  selector: 'app-account-delete',
  templateUrl: './account-delete.component.html',
  styleUrls: ['./account-delete.component.scss']
})
export class AccountDeleteComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    phone: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    schedule: new FormControl('', [Validators.required]),
    reason: new FormControl('', [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    contactByEmail: new FormControl(true, [Validators.required]),
    contactByPhone: new FormControl(true, [Validators.required])
  });
  private user: User;
  public reasonsData: Array<MetaData> = [];

  constructor(
    public dialog: MatDialogRef<AccountDeleteComponent>,
    private uiService: UiService,
    private userService: UserService,
    private platformService: PlatformService,
    private accountsService: AccountsService,
    private productsService: ProductsService,
    private proceduresService: ProceduresService,
  ) {
    this.userService.currentUser.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.uiService.showSpinner(true);

    this.productsService.reasonsGet().then((success) => {
      this.uiService.showSpinner(false);

      this.reasonsData = success.result;

      this.formData.setValue({
        phone: this.user.phone,
        email: this.user.email,
        schedule: '',
        reason: '',
        comment: '',
        contactByEmail: true,
        contactByPhone: true,
      });
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.dialog.close();
      this.uiService.dialogShow('Ups!', 'No es posible solicitar la baja de tu cuenta en este momento (#0001). Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.accountsService.accountDelete(
        this.formData.get('reason')?.value,
        this.formData.get('comment')?.value,
        this.formData.get('phone')?.value,
        this.formData.get('email')?.value,
        this.formData.get('schedule')?.value,
        this.formData.get('contactByEmail')?.value,
        this.formData.get('contactByPhone')?.value
      ).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.proceduresService.proceduresUpdate(true);
          this.userService.updateData('unsuscribeAccount', true);
          this.accountsService.accountsDataUpdate();

          this.uiService.dialogShow('Solicitar baja de la cuenta', 'Recibimos correctamente tu solicitud de baja. Un asesor se comunicará en las próximas 48 horas hábiles. Tu número de gestión es: <p><h1>' + result.result.id + '</h1></p>', 'success');
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar solicitar la baja de tu cuenta. Por favor intenta nuevamente.', 'error');
        }
      }).catch((error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible solicitar la baja de tu cuenta en este momento (#0002). Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      phone: {
        required:  'Ingresá un teléfono de contacto'
      },
      email: {
        required:  'Ingresá un email de contacto'
      },
      schedule: {
        required:  'Indicanos un horario de contacto'
      },
      reason: {
        required:  'Seleccioná un motivo'
      },
      comment: {
        required:  'Indicanos porqué queres darle de baja al producto'
      }
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
